module.exports = __webpack_public_path__ + "img/1970East-030_WEB-min.6b684c4d.jpg";